import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class IDTRate extends ModelBase {
    static typeName = "IDTRate";

    public idtRateId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rateDate: Date | null = null;

    @Attributes.Float()
    @Attributes.Display("IDT Rate")
    public idtr: number = 0;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.idtr < 0, "IDT Rate cannot be negative");
    }

    public toString(): string {
        if (this.isNew) {
            return "New IDT rate";
        } else {
            return "IDT Rate";
        }
    }
}